import { API } from "@/api";

/**
 * Fetch a protected file (chef document, photo, etc.) with the current JWT and
 * return a blob URL that can be assigned to <img src> or opened via window.open.
 *
 * The caller is responsible for revoking the URL when done (URL.revokeObjectURL).
 * Returns null on failure so callers can fall back to a placeholder.
 */
export async function fetchAuthedBlobUrl(path) {
  const token = localStorage.getItem("chulha_token");
  if (!token) return null;
  try {
    const url = path.startsWith("http") ? path : `${API}${path}`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return null;
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

/** Open a protected file in a new tab using the auth token. */
export async function openAuthedInNewTab(path) {
  const blobUrl = await fetchAuthedBlobUrl(path);
  if (!blobUrl) return false;
  window.open(blobUrl, "_blank", "noopener,noreferrer");
  // Revoke after 60 s — plenty of time for the browser to load the tab.
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  return true;
}
